import React, { useState } from 'react';
import Icon from '../../../Assets/Icon/CustomIcon';

export default function InputText({
  label,
  value,
  onChange,
  placeholder,
  type = 'text',
  required = false,
  disabled = false,
  error = '',
  maxLength,
  inputMode,
  setError,
}) {
  const [isFocused, setIsFocused] = useState(false);

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      e.target.blur();
    }
  };

  const handleChange = (e) => {
    const newValue = e.target.value;

    onChange(e);

    if (setError) {
      if (label === '제목' && newValue.trim() === '') {
        setError('제목을 입력하세요.');
      } else if (label === '내용' && newValue.trim() === '') {
        setError('내용을 입력하세요.');
      } else {
        setError('');
      }
    }
  };

  return (
    <div
      style={{ display: 'flex', flexDirection: 'column', marginBottom: '8px' }}
    >
      <div style={{ display: 'flex', alignItems: 'center' }}>
        {label && (
          <label
            style={{
              fontWeight: 'bold',
              fontSize: '16px',
              color: '#2c2c2cff',
              marginBottom: '4px',
            }}
          >
            {label}
          </label>
        )}
        <span
          style={{
            marginLeft: '8px',
            fontSize: '16px',
            color: error ? '#E65959' : '#4C48BE',
          }}
        >
          {error ? <Icon.Caution /> : value.trim() !== '' && <Icon.Check />}
        </span>
      </div>
      <div style={{ position: 'relative', width: '100%' }}>
        <textarea
          type={type}
          value={value}
          onChange={handleChange}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          onKeyDown={handleKeyDown}
          placeholder={placeholder}
          required={required}
          disabled={disabled}
          maxLength={maxLength}
          inputMode={inputMode}
          style={{
            width: '100%',
            padding: '8px',
            borderRadius: '8px',
            border: '1px solid #C4C4C4',
            borderColor: error ? '#E65959' : isFocused ? '#4C48BE' : '#C4C4C4',
            fontSize: '16px',
            fontWeight: 'bold',
            transition: 'border-bottom-color 0.2s',
            outline: 'none',
            resize: 'none',
            minHeight: label === '내용' && '100px',
            ...(disabled && {
              backgroundColor: '#f0f0f0',
              cursor: 'not-allowed',
            }),
          }}
        />
      </div>

      {error && (
        <span
          style={{
            color: '#E65959',
            fontSize: '14px',
            marginLeft: '4px',
          }}
        >
          {error}
        </span>
      )}
    </div>
  );
}
